<template>
    <v-container>
        <!--<v-row>-->
            <!--<div class="d-flex d-sm-none">XS</div>-->
            <!--<div class="d-none d-sm-flex d-md-none">SM</div>-->
            <!--<div class="d-none d-md-flex d-lg-none">MD</div>-->
            <!--<div class="d-none d-lg-flex d-xl-none">LG</div>-->
            <!--<div class="d-none d-xl-flex">XL</div>-->
        <!--</v-row>-->
        <v-row v-if="loading" align="center"
               justify="center">

            <v-col
                    cols="12"
            >
                <v-text-field color="grey" loading disabled></v-text-field>
            </v-col>
        </v-row>
        <v-row v-else-if="tpl == 'product'">
            <v-col cols="12">
            </v-col>
            <!-- mobile -->
            <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'en' ">{{ page.name_en }}</h1>
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'es' ">{{ page.name_es }}</h1>
                <h1 class="font-weight-bold display-1 text-center" v-if="lang == 'pt' ">{{ page.name_pt }}</h1>
                <v-rating
                        class="text-center"
                        v-model="page.reviews.average"
                        half-increments
                        background-color="orange lighten-3"
                        color="orange"
                        small
                        readonly
                        dense
                ></v-rating>
                <div>
                    <v-carousel :show-arrows="false">
                        <v-carousel-item
                                v-for="(img,i) in page.images"
                                :key="i"
                                :src="'https://cdn.ppsbrands.com/products/'+img.image"
                                reverse-transition="fade-transition"
                                transition="fade-transition"
                        ></v-carousel-item>
                    </v-carousel>
                </div>
                <p class="font-weight-medium display-1 accent--text text-center mt-5">${{ page.price | number_format_real}}</p>
                <div v-if="page.stock == 1">
                    <strong v-if="lang == 'en' ">In Stock</strong>
                    <strong v-if="lang == 'pt' ">Em estoque</strong>
                    <strong v-if="lang == 'es' ">En stock</strong>
                </div>
                <div v-else>
                    <strong v-if="lang == 'en' ">Out of stock</strong>
                    <strong v-if="lang == 'pt' ">Fora de estoque</strong>
                    <strong v-if="lang == 'es' ">Agotado</strong>
                </div>
                <div>
                    <strong v-if="lang == 'en' ">Product Code</strong>
                    <strong v-if="lang == 'pt' ">Código do produto</strong>
                    <strong v-if="lang == 'es' ">Código de producto</strong>
                    : {{page.code}}
                </div>
                <div class="mt-5">
                    <ul>
                        <li v-for="(bullets,index) in page.bullets_en" :key="index" v-if="lang == 'en'">{{bullets}}</li>
                        <li v-for="(bullets,index) in page.bullets_es" :key="index" v-if="lang == 'es'">{{bullets}}</li>
                        <li v-for="(bullets,index) in page.bullets_pt" :key="index" v-if="lang == 'pt'">{{bullets}}</li>
                    </ul>
                </div>
            </v-col>
            <!-- desktop -->
            <!--images-->
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">
                <v-row>
                    <v-col cols="3" xl="2" lg="3" md="3">
                        <v-container fluid v-if="page.images">
                            <v-row>
                                <v-col
                                        v-for="(image,index) in page.images"
                                        :key="index"
                                        class="d-flex child-flex"
                                        cols="12"
                                >
                                    <v-card flat outlined :hover="true" class="d-flex">
                                        <v-img
                                                :src="'https://cdn.ppsbrands.com/products/'+image.image"
                                                :lazy-src="'https://cdn.ppsbrands.com/products/'+image.image"
                                                class="grey lighten-2"
                                                @click="changeImage('https://cdn.ppsbrands.com/products/'+image.image)"
                                        >
                                            <template v-slot:placeholder>
                                                <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                >
                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                            </template>
                                        </v-img>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col cols="10" xl="10" lg="9" md="9">
                        <v-img
                                v-if="page.images"
                                :src="imgDefault"
                                :lazy-src="imgDefault"
                                aspect-ratio="1"
                                class="grey lighten-2"
                        >
                        </v-img>
                    </v-col>
                </v-row>
            </v-col>
            <!--details-->
            <v-col cols="6" v-if="$vuetify.breakpoint.mdAndUp">
                <h1 class="font-weight-bold display-1" v-if="lang == 'en' ">{{ page.name_en }}</h1>
                <h1 class="font-weight-bold display-1" v-if="lang == 'es' ">{{ page.name_es }}</h1>
                <h1 class="font-weight-bold display-1" v-if="lang == 'pt' ">{{ page.name_pt }}</h1>
                <v-rating
                        v-model="page.reviews.average"
                        half-increments
                        background-color="orange lighten-3"
                        color="orange"
                        medium
                        readonly
                        dense
                ></v-rating>
                <p class="subtitle-2">
                    <span v-if="lang == 'en' ">Brand</span>
                    <span v-if="lang == 'pt' ">Marca</span>
                    <span v-if="lang == 'es' ">Marca</span>
                    :
                    <span class="font-weight-bold" v-if="lang == 'en' ">{{ this.page.manufacturer_en }}</span>
                    <span class="font-weight-bold" v-if="lang == 'es' ">{{ this.page.manufacturer_es }}</span>
                    <span class="font-weight-bold" v-if="lang == 'pt' ">{{ this.page.manufacturer_pt }}</span>
                </p>
                <p class="font-weight-medium display-1 accent--text">${{ page.price | number_format_real}}</p>
                <div class="mb-6">
                    <ul>
                        <li v-for="(bullets,index) in page.bullets_en" :key="index" v-if="lang == 'en'">{{bullets}}</li>
                        <li v-for="(bullets,index) in page.bullets_es" :key="index" v-if="lang == 'es'">{{bullets}}</li>
                        <li v-for="(bullets,index) in page.bullets_pt" :key="index" v-if="lang == 'pt'">{{bullets}}</li>
                    </ul>
                </div>
            </v-col>
            <!--button-->
            <v-col cols="2" v-if="$vuetify.breakpoint.mdAndUp">
                <v-card outlined>
                    <v-card-text>
                        <p class="font-weight-medium display-1 accent--text">${{ page.price | number_format_real}}</p>
                        <div v-if="page.stock == 1">
                            <strong v-if="lang == 'en' ">In Stock</strong>
                            <strong v-if="lang == 'pt' ">Em estoque</strong>
                            <strong v-if="lang == 'es' ">En stock</strong>
                        </div>
                        <div v-else>
                            <strong v-if="lang == 'en' ">Out of stock</strong>
                            <strong v-if="lang == 'pt' ">Fora de estoque</strong>
                            <strong v-if="lang == 'es' ">Agotado</strong>
                        </div>
                        <div>
                            <strong v-if="lang == 'en' ">Product Code</strong>
                            <strong v-if="lang == 'pt' ">Código do produto</strong>
                            <strong v-if="lang == 'es' ">Código de producto</strong>
                            : {{page.code}}
                        </div>
                        <v-col cols="12" v-if="page.stock == 1">
                            <v-select
                                    :items="quanty"
                                    label="Quantity"
                                    v-model="qty"
                                    v-if="lang == 'en' "
                            ></v-select>
                            <v-select
                                    :items="quanty"
                                    label="Cantidad"
                                    v-model="qty"
                                    v-if="lang == 'es' "
                            ></v-select>
                            <v-select
                                    :items="quanty"
                                    label="Quantidade"
                                    v-model="qty"
                                    v-if="lang == 'pt' "
                            ></v-select>
                        </v-col>
                        <div class="row mb-8 row--dense" v-if="page.stock == 1">
                            <v-col cols="12">
                                <v-btn
                                        type="button"
                                        :loading="load.addCart"
                                        class="mb-6 mb-md-0 v-btn v-btn--contained theme--light v-size--x-large text-none orange"
                                        @click="addProductCart(page.id)"
                                >
                                    <span v-if="lang == 'en' ">Add To Cart</span>
                                    <span v-if="lang == 'pt' ">Comprar</span>
                                    <span v-if="lang == 'es' ">Añadir a la cesta</span>
                                </v-btn>
                            </v-col>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <!--descriptions-->
            <v-col cols="12" v-if="lang == 'en' ">
                <p class="font-weight-medium headline text-center">Product Description</p>
                <hr>
                <div v-html="page.descricao_en"></div>
            </v-col>
            <v-col cols="12" v-if="lang == 'es' ">
                <p class="font-weight-medium headline text-center">Descripción del producto</p>
                <hr>
                <div v-html="page.descricao_es"></div>
            </v-col>
            <v-col cols="12" v-if="lang == 'pt' ">
                <p class="font-weight-medium headline text-center">Descrição do Produto</p>
                <hr>
                <div v-html="page.descricao_pt"></div>
            </v-col>
            <!--Reviews-->
            <v-col cols="12">
                <hr>
                <p class="font-weight-medium headline text-center" v-if="lang == 'en' ">Product Review</p>
                <p class="font-weight-medium headline text-center" v-if="lang == 'pt' ">Avaliações</p>
                <p class="font-weight-medium headline text-center" v-if="lang == 'es' ">Revision de producto</p>
                <hr>
                <v-row>
                    <v-col cols="12" md="6" style="max-height: 300px; overflow: auto">
                        <v-card v-for="(n,index) in page.reviews.reviews" :key="index">
                            <v-row justify="space-between">
                                <v-col cols="12">
                                    <v-card-title>
                                        <div>
                                            <div>{{n.name}}</div>
                                            <v-card-actions class="pa-0">
                                                    <span class="black-text text--lighten-2 caption mr-2">
                                                    ({{ n.rate }})
                                                  </span>
                                                <v-rating
                                                        v-model="n.rate"
                                                        background-color="white"
                                                        color="yellow accent-4"
                                                        dense
                                                        half-increments
                                                        readonly
                                                        size="18"
                                                ></v-rating>
                                            </v-card-actions>
                                            <div class="caption">
                                                {{n.note}}
                                            </div>
                                        </div>
                                    </v-card-title>
                                </v-col>
                            </v-row>
                        </v-card>
                        <p v-if="page.reviews.total == 0" class="headline text-center">Be the first to review our product</p>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-alert type="success" v-if="review.send">
                            Thank you for your review
                        </v-alert>
                        <v-form
                                v-else
                                ref="formReview"
                        >
                            <v-rating
                                    v-model="review.value"
                                    half-increments
                                    background-color="orange lighten-3"
                                    color="orange"
                                    medium
                                    hover
                                    dense
                            ></v-rating>
                            <v-text-field
                                    v-model="review.name"
                                    :rules="nameRules"
                                    label="Name"
                                    required
                            ></v-text-field>
                            <v-textarea
                                    v-model="review.description"
                                    :rules="reviewRules"
                                    maxlength="200"
                                    clearable
                                    required
                                    counter="200"
                                    label="Write a review"
                                    rows="1"
                            ></v-textarea>
                            <br>
                            <v-btn
                                    large
                                    color="orange"
                                    dark
                                    @click="sendReview"
                                    :loading="load.review"
                            >
                                Send
                            </v-btn>
                        </v-form>
                    </v-col>
                </v-row>
            </v-col>
            <!--related-->
            <v-col cols="12">
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'en' ">You Might Also Like</p>
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'pt' ">Você pode gostar também</p>
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'es' ">También podría gustarte</p>
                <hr>
                <v-row>
                    <v-col
                            cols="6"
                            lg="3"
                            md="3"
                            sm="6"
                            xs="6"
                            v-for="(product,index) in products"
                            :key="index"

                    >
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/'+product.url_en"
                                v-if="lang=='en'"
                        >

                            <v-img
                                    v-if="product.images && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-if="product.images && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        @click="addProductCart(product.id)"
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/es/'+product.url_en"
                                v-if="lang=='es'"
                        >
                            <v-img
                                    v-if="product.images"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                        @click="addProductCart(product.id)"
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/pt/'+product.url_en"
                                v-if="lang=='pt'"
                        >
                            <v-img
                                    v-if="product.images"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                        @click="addProductCart(product.id)"
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-btn @click="addProductCart(page.id)" :loading="load.addCart" type="button" class="v-btn v-size--x-large text-none orange" style="position: fixed;bottom: 0;width: 100%;z-index: 999;" v-if="$vuetify.breakpoint.smAndDown && page.stock == 1">
                <span v-if="lang == 'en' ">Add To Cart</span>
                <span v-if="lang == 'pt' ">Comprar</span>
                <span v-if="lang == 'es' ">Añadir a la cesta</span>

            </v-btn>
            <script type="application/ld+json" v-if="page.reviews.total > 0">
                {
                    "@context": "http://schema.org",
                    "@type": "Product",
                    "description": "{{ page.description_en }}",
                    "name": "{{ page.name_en }}",
                    "sku": "{{ page.code }}",
                    "gtin8": "{{ page.code }}",
                    "brand":{
                        "@type":"Brand",
                        "name":"Dearskin LLC"
                    },
                    "image": "{{ imgDefault }}",
                    "offers": {
                        "@type": "Offer",
                        "price": "{{ page.price | number_format_real}}",
                            "priceCurrency": "USD",
                            "availability":"InStock",
                            "priceValidUntil":"{{ page.reviews.date }}",
                            "url":"https://www.ppsbrands.com/{{ page.url_en }}"
                     },
                     "aggregateRating":
                    {
                        "@type":"AggregateRating",
                        "ratingValue":{{ page.reviews.average }},
                        "reviewCount":"{{ page.reviews.total }}",
                        "bestRating":"5",
                        "worstRating":1
                    },
                    "review": [
                        {
                            "@type": "Review",
                            "author": {
                                "@type": "Person",
                                "name":"{{ page.reviews.reviews[0].name }}"
                            },
                            "datePublished": "{{ page.reviews.reviews[0].date }}",
                            "description": "{{ page.reviews.reviews[0].note }}",
                            "name":"{{ page.reviews.reviews[0].name }}",
                            "reviewRating": {
                                "@type": "Rating",
                                "bestRating": "5",
                                "ratingValue": "{{ page.reviews.reviews[0].rate }}",
                                "worstRating": "1"
                            }
                        }
                    ]
                }
            </script>
        </v-row>
        <v-row v-else-if="tpl == 'brand'">
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'en' ">{{ page.name_en }}</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'es' ">{{ page.name_es }}</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'pt' ">{{ page.name_pt }}</h1>
                <hr>
                <v-row>
                    <v-col
                            cols="6"
                            lg="3"
                            md="3"
                            sm="6"
                            xs="6"
                            v-for="(product,index) in page.products"
                            :key="index"

                    >
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/'+product.url_en"
                                v-if="lang=='en'"
                        >

                            <v-img
                                    v-if="product.images && product.stock && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-if="product.images && product.stock == 0 && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-if="product.images && product.stock && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-if="product.images && product.stock == 0 && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions >
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        @click="addProductCart(product.id)"
                                        v-if="product.stock"
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                                <v-btn
                                        v-else-if="$vuetify.breakpoint.xsOnly"
                                        color="red"
                                        style="color: #0d47a1;"
                                        icon
                                >

                                    <v-img src="../assets/img/not_avaliable.png" width="40px" ></v-img>
                                </v-btn>
                                <v-btn
                                        v-else
                                        color="red"
                                        style="color: #0d47a1;"
                                        text
                                        outlined
                                >
                                    NOT AVALIABLE
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/es/'+product.url_en"
                                v-if="lang=='es'"
                        >
                            <v-img
                                    v-if="product.images"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                        @click="addProductCart(product.id)"
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/pt/'+product.url_en"
                                v-if="lang=='pt'"
                        >
                            <v-img
                                    v-if="product.images"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                        @click="addProductCart(product.id)"
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            lang: { type: String },
            cartVisible: { type: Boolean },
        },
        metaInfo () {
            return {
                title: this.title,
                meta: [
                    {description: this.description},
                    {keywords: this.keywords}
                ]
            }
        },
        data () {
            return {
                title:"PPS Brands",
                description:"PPS Brands",
                keywords:"PPS Brands",
                loading:true,
                rating:4.8,
                review:{
                  value:5,
                  name:"",
                  description:"",
                  send:false,
                },
                current:window.location.pathname,
                tpl:"home",
                quanty: ['1', '2', '3', '4','5','6','7','8','9','10'],
                qty:'1',
                products: [
                    {
                        name: ' ',
                        images:false
                    },
                    {
                        name: ' ',
                        images:false
                    },
                    {
                        name: ' ',
                        images:false
                    },
                    {
                        name: ' ',
                        images:false
                    },
                ],
                page:{
                    images:false,
                    price:0,
                    imgDefault:"aaa"
                },
                imgDefault:"",
                load:{
                    addCart:false,
                    review:false
                },
                nameRules: [
                    v => !!v || 'Name is required'
                ],
                reviewRules: [
                    v => !!v || 'Review is required'
                ]
            }
        },
        methods:{
            init() {
                var u1 = this.current.split('/');
                u1 = u1.pop();
                var u2 = window.location.pathname.split('/');
                u2 = u2.pop();
                if(u1 != u2){
                    this.current = window.location.pathname;
                    this.loading = true;
                    this.loadPage();
                }
            },
            loadPage(){
                this.$http.get("https://api.ppsbrands.com/store/getPage/"+this.$route.params.urlPage).then(response =>{
                    this.loading = false;
                    if(response.data.erro){
                        console.log('404')
                    }else if(response.data.tpl == 'product'){
                        this.tpl = 'product';
                        this.page = response.data.data;
                        this.page.bullets_en = JSON.parse(this.page.bullets_en);
                        this.page.bullets_es = JSON.parse(this.page.bullets_es);
                        this.page.bullets_pt = JSON.parse(this.page.bullets_pt);
                        this.page.reviews.average = parseFloat(this.page.reviews.average);
                        this.imgDefault = 'https://cdn.ppsbrands.com/products/'+this.page.images[0].image;
                        if(this.lang == 'en'){
                            this.title = this.page.title_en;
                            this.description = this.page.description_en;
                            this.keywords = this.page.keywords_en;
                        }else if(this.lang == 'es'){
                            this.title = this.page.title_es;
                            this.description = this.page.description_es;
                            this.keywords = this.page.keywords_es;
                        }else{
                            this.title = this.page.title_pt;
                            this.description = this.page.description_pt;
                            this.keywords = this.page.keywords_pt;
                        }
                        this.$http.get("https://api.ppsbrands.com/store/home").then(response =>{
                            this.products = response.data.products;
                        });
                    }else if(response.data.tpl == 'brand'){
                        this.tpl = 'brand';
                        this.page = response.data.data;
                        if(this.lang == 'en'){
                            this.title = this.page.title_en;
                            this.description = this.page.description_en;
                            this.keywords = this.page.keywords_en;
                        }else if(this.lang == 'es'){
                            this.title = this.page.title_es;
                            this.description = this.page.description_es;
                            this.keywords = this.page.keywords_es;
                        }else{
                            this.title = this.page.title_pt;
                            this.description = this.page.description_pt;
                            this.keywords = this.page.keywords_pt;
                        }
                    }else{
                        console.log('404')
                    }
                });
            },
            changeImage(src){
                this.imgDefault = src;
            },
            addProductCart(id){
                var arr = {
                    token:localStorage.token,
                    id:id,
                    qty:this.qty
                };
                arr = JSON.stringify(arr);
                this.load.addCart = true;
                this.$http.post("https://api.ppsbrands.com/store/cart/add",arr).then(response => {
                    if(response){
                        this.load.addCart = false;
                        this.$emit('displayCart', true);
                    }

                });

            },
            sendReview(){
                if (this.$refs.formReview.validate()) {
                    this.load.review = true;
                    var arr = {
                        review:this.review.value,
                        name:this.review.name,
                        description:this.review.description,
                        product:this.page.id
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/product/review",arr).then(response => {
                        this.load.review = false;
                        this.review.send = true;
                        if(response){
                            this.load.review = false;
                        }
                        this.review.name = "";
                        this.review.description = "";
                    });
                }
            }
        },
        mounted(){
            this.$emit('showCart');
            this.loadPage();
            var self = this;
            setInterval(function(){
                    self.init();
                }, 700
            );
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>